// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"992":"78db9820","1147":"d5ca046a"}[chunkId] + ".chunk.css";
};